<template>
  <div v-if="userDetail">
    <!-- main -->
    <app-main style="min-height: 100vh" />
    <!-- main -->
    <!-- footer -->
    <footer v-if="getFooter">
      <ul class="clearfix">
        <router-link :to="{ name: 'home' }">
          <li @click="getNewupdate()" :class="currentRouteName == 'home' ? 'active' : ''">
            <img
              v-if="currentRouteName == 'home'"
              src="~@/assets/images/menu01a.svg"
            />
            <img v-else src="~@/assets/images/menu01.svg" />
          </li>
        </router-link>
        <router-link :to="{ name: 'timeline' }">
          <li @click="getNewupdate()" :class="currentRouteName == 'timeline' ? 'active' : ''">
            <img
              v-if="currentRouteName == 'timeline'"
              src="~@/assets/images/menu02a.svg"
            />
            <img v-else src="~@/assets/images/menu02.svg" />
          </li>
        </router-link>
        <router-link :to="{ name: 'like' }">
          <li @click="getNewupdate()" :class="currentRouteName == 'like' ? 'active' : ''">
            <img
              v-if="currentRouteName == 'like'"
              src="~@/assets/images/menu03a.svg"
            />
            <img v-else src="~@/assets/images/menu03.svg" />
            <p class="alert" v-if="parseInt(userDetail.is_new_like) > 0"></p>
          </li>
        </router-link>
        <router-link :to="{ name: 'message' }">
          <li @click="getNewupdate()" :class="currentRouteName == 'message' ? 'active' : ''">
            <img
              v-if="currentRouteName == 'message'"
              src="~@/assets/images/menu04a.svg"
            />
            <img v-else src="~@/assets/images/menu04.svg" />
            <p class="alert" v-if="parseInt(userDetail.is_new_message) > 0"></p>
          </li>
        </router-link>
        <router-link :to="{ name: 'profile' }">
          <li :class="currentRouteName == 'profile' ? 'active' : ''">
            <img
              v-if="currentRouteName == 'profile'"
              src="~@/assets/images/menu05a.svg"
            />
            <img v-else src="~@/assets/images/menu05.svg" />
            <p class="f-menu">
              <img
                v-if="!userDetail.avatar_url"
                src="~@/assets/images/profile_man.png"
              />
              <img v-else :src="getImageUrl(userDetail.avatar_url)" />
            </p>
            <p class="alert" v-if="parseInt(userDetail.is_new_notice) + parseInt(userDetail.is_new_campaign) + parseInt(userDetail.is_new_footprint) > 0"></p>
          </li>
        </router-link>
      </ul>
    </footer>
    <!-- footer -->
    <!-- modal -->
    <modal
      v-if="currentRouteName == 'home'"
      :is-show="isShowModal"
      @close="isShowModal = false"
      :banner="banner"
    ></modal>

    <div class="call_pages" id="call_pages" style="display: none">
      <!-- Start call page -->
      <div id="start_call_page" style="display: none">
        <div id="start_call_calling">
          <p style="color: white">calling...</p>
        </div>
        <div class="chat-img" style="position: inherit;">
            <img id="call_avatar"/>
        </div>
        <div id="start_call">
          <button
            class="btn_close_start_call"
            @click="this.$store.dispatch('call/cancelStartCall')"
          >
            Close call
          </button>
        </div>
      </div>

      <!-- Coming call page -->
      <div id="coming_call_page" style="display: none">
        <div id="coming_call_close">
          <button
            class="btn_coming_call_close"
            @click="this.$store.dispatch('call/denyComingCall')"
          >
            Deny coming call
          </button>
        </div>

        <div id="coming_call_accept">
          <button
            class="btn_coming_call_accept"
            @click="this.$store.dispatch('call/acceptComingCall', {pointSetting: pointSetting})"
          >
            Accept coming call
          </button>
        </div>
      </div>

      <!-- received gift -->
      <div id="received_gift"></div>

      <!-- Show remote video -->
      <div id="show_remote_video" style="display: none;">
          <video id="remote_video_call" width="200" height="100" style="padding-left: 45%;" autoplay></video>
      </div>

      <!-- count time -->
      <p id="call_count_time" style="display: none; padding-left: 45%; color: white;"></p>

      <!-- Show my video -->
      <div id="show_my_video" style="display: none;">
          <video id="my_video_call" width="400" height="230" autoplay></video>
      </div>

        <!-- Calling page -->
        <div id="calling_page" style="display: none;">
            <div class="blur_slide_container" id="blur_slide">
                <input type="range" min="0" max="10" v-model="blurVal" @change="this.$store.dispatch('call/blurVideo', blurVal)">
            </div>

            <div id="call_mute">
                <button class="btn_call_mute" @click="this.$store.dispatch('call/muteUnMuteAudio')">Mute</button>
            </div>

            <div id="call_off_camera">
                <button class="btn_call_off_camera" @click="this.$store.dispatch('call/onOffCamera')">Off camera</button>
            </div>

            <div id="finish_call">
                <button class="btn_finish_call" @click="this.$store.dispatch('call/finishCall')">Finish call</button>
            </div>

            <!-- Gift -->
            <ul class="chat5 clearfix" v-if="pointSetting">
                <li v-for="item in pointSetting.gifts.result" :key="item.id" @click="this.$store.dispatch('call/sendGift', {giftId: item.id, pointSetting: pointSetting})">
                    <img :src="getImageUrl(item.image)" />
                </li>
            </ul>
        </div>
    </div>
  </div>
</template>

<script>
import AppMain from "./AppMain";
import modal from "./components/modal";
import CONSTANTS from "@/constants";
import mixin from "@/mixin";
import { getLoginBonus, getLoginDayNumber, setLoginBonus } from "@/auth";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Layout",
  components: {
    AppMain,
    modal,
  },
  mixins: [mixin],
  data: () => ({
    isShowModal: true,
    IS_BONUS: CONSTANTS.IS_BONUS,
    banner: null,
    xDown: "",
    yDown: "",
    xDiff: "",
    yDiff: "",
    xLength: "",
    footerTabs: ["home", "timeline", "like", "message", "profile"],
    blurVal: 0,
    pointSetting: null,
    is_new_like: 0,
  }),
  mounted() {
    // this.eventListenSwipe();
    this.$store.dispatch("route/hideLoading")
    setTimeout(() => {
      if (parseInt(getLoginBonus()) === this.IS_BONUS) {
        const loginDayNumber = getLoginDayNumber() == 0 ? "3" : getLoginDayNumber();
        this.isShowModal = true;
        this.banner = {
          title: require("@/assets/images/login0" +
            loginDayNumber +
            "a.png"),
          body: require("@/assets/images/login0" + loginDayNumber + "b.png"),
        };
        setLoginBonus(0);
      }
    }, 1000)
    if (!this.userDetail) {
      this.userProfile({
        token: this.getDefaultToken({
          len: 32,
        }),
      });
    }

    this.getPointFee();
  },
  computed: {
    ...mapGetters(["userDetail", "isFooter"]),
    currentRouteName() {
      return this.$route.name;
    },
    getFooter() {
      if (
        this.currentRouteName !== "search" &&
        this.currentRouteName !== "buyPoint" &&
        this.currentRouteName !== "timelineDetail" &&
        this.currentRouteName !== "userDetail" &&
        this.currentRouteName !== "chat" &&
        this.isFooter &&
        this.currentRouteName !== "campaign" &&
        this.currentRouteName !== "campaignDetail" &&
        this.currentRouteName !== "editProfile"
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions({
      userProfile: "user/userProfile",
      getDefaultToken: "user/getDefaultToken",
    }),
    // eventListenSwipe() {
    //   document.addEventListener("touchstart", this.handleTouchStart, false);
    //   document.addEventListener("touchmove", this.handleTouchMove, false);
    //   document.addEventListener("touchend", this.handleTouchEnd, false);
    // },
    // handleTouchStart(evt) {
    //   evt.stopPropagation();

    //   this.xDown = evt.touches[0].clientX;
    //   this.yDown = evt.touches[0].clientY;
    // },
    // handleTouchMove(evt) {
    //   evt.stopPropagation();

    //   if (!this.xDown || !this.yDown) {
    //     return;
    //   }

    //   const xUp = evt.touches[0].clientX;
    //   const yUp = evt.touches[0].clientY;

    //   this.xDiff = this.xDown - xUp;
    //   this.yDiff = this.yDown - yUp;
    //   this.xLength = Math.abs(this.xDown - xUp);
    // },
    // handleTouchEnd() {
    //   if (Math.abs(this.xDiff) > Math.abs(this.yDiff) && this.xLength > 30) {
    //     const index = this.footerTabs.indexOf(this.$route.name);

    //     /*most significant*/
    //     if (this.xDiff > 0) {
         
    //       /* left swipe */
    //       if (index !== -1 && this.footerTabs[index + 1]) {
    //         this.$router.push({ name: this.footerTabs[index + 1] });
    //       }

    //     } else {
    //       if (index !== -1 && this.footerTabs[index - 1]) {
    //         this.$router.push({ name: this.footerTabs[index - 1] });
    //       }

    //     }
    //   }

    //   this.resetValue();
    // },

    // resetValue() {
    //   /* reset values */
    //   this.xDown = "";
    //   this.yDown = "";
    //   this.xDiff = "";
    //   this.yDiff = "";
    //   this.xLength = "";
    // },

    getPointFee() {
        this.$store
            .dispatch("user/getPointFee", {
                token: this.getDefaultToken,
            })
            .then((data) => {
                this.pointSetting = data;
            })
            .catch((err) => {
                console.log(err);
            });
    },

    getNewupdate() {
        this.$store.dispatch("user/getNewUpdate", {
          token: this.getDefaultToken
        }).then((data) => {
          if (data) {
            this.userDetail.is_new_footprint = data.is_new_footprint
            this.userDetail.is_new_campaign = data.is_new_campaign
            this.userDetail.is_new_message = data.is_new_message
            this.userDetail.is_new_notice = data.is_new_notice

            if (window.location.pathname.includes('like')) {
                this.userDetail.is_new_like = 0
            } else {
                this.userDetail.is_new_like = data.is_new_like
            }
          }

        }).catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>